module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 134.3d40a968.png";